module.exports = __webpack_public_path__ + "img/location.bf52f3a9.png";